import { TrackerOption, AppOption } from '../types';

type FormatParams = [string | undefined, boolean | undefined, AppOption | undefined];

const normalizeOption = ([value, manual, appOption]: FormatParams) => {
  if (!value) return undefined;
  if (manual) return { label: value, value };
  return appOption?.trackerOptions.find(option => option.value === value);
};

export const combineResult = (options: TrackerOption[]) => ({
  title: options.map(option => option.label).join(' / '),
  trackerToken: options.map(option => option.value).join('_'),
});

export const formatTrackerToken = (formatParams: FormatParams[]) =>
  combineResult(formatParams.map(normalizeOption).filter(Boolean) as TrackerOption[]);
